import gql from "graphql-tag";

// compact inquiry shape for the dashboard rows — enough to render + open the detail
const DASH_INQUIRY = `
  id
  name
  email
  phone
  state
  topic
  message
  createdAt
  createdAtTime
  visitorId
  leadTier
  leadScore
  property { id propertyType fullAddress }
`;

// "Para hoy" — the ranked daily action feed (scope: mine | managed | global)
export const SalesDashboard = gql`
  query salesDashboard($scope: String) {
    salesDashboard(scope: $scope) {
      scope
      unansweredCount
      expiredCount
      unanswered { ${DASH_INQUIRY} }
      hotOpen { ${DASH_INQUIRY} }
      stale { ${DASH_INQUIRY} }
      unassigned { ${DASH_INQUIRY} }
      hotProperties {
        openInquiries
        recentVisits
        property { id propertyType fullAddress state }
      }
      pipeline { label count }
      agentWorkload { name open }
      pulse { newThisWeek newPrevWeek inProgress wonThisMonth }
    }
  }
`;
